
import { supabase } from '../client';

export const deleteProduct = async (id: string): Promise<boolean> => {
  try {
    console.log(`Deleting product with ID: ${id}`);
    
    const { error } = await supabase
      .from('products')
      .delete()
      .eq('id', id);
    
    if (error) {
      console.error('Error deleting product:', error);
      throw error;
    }
    
    console.log(`Successfully deleted product with ID: ${id}`);
    return true;
  } catch (error) {
    console.error('Failed to delete product:', error);
    throw error; // Re-throw to be handled by the calling function
  }
};
